var LikeVote = function () {
	var likeClick = function () {
		$('.js-like-btn').click(function () {
			var $error = $('.js-like-error');
			var $vote = $('.js-like-vote');
			var $result = $('.js-like-result');
			var $score = $('.js-like-score');

			$error.addClass('hidden');

			$.ajax({
				url: '/ajax/like',
				type: 'POST',
				data: {
					content: $(this).data('content'),
					vote: $(this).data('vote')
				},
				success: function(data) {
					$score.text(data.score);
					$vote.addClass('hidden');
					$result.removeClass('hidden');
				},
				error: function() {
					$error.removeClass('hidden');
				}
			});
		});
	};

	var init = function () {
		likeClick();
	};

	return {
		init: init
	};
}();

UL.register(LikeVote);
